module.exports = __webpack_public_path__ + "static/media/35.d4970c6b.mp3";